// Release Switch Toggles: should not be used directly
// @see getReleaseSwitchToggleCookieName util
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_SWITCH_TOGGLE_AT = 'release-switch-at'

// Release Toggles
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const RELEASE_TOGGLE_CART_CTA_DELAYED = 'cart-cta-delayed'
export const RELEASE_TOGGLE_ERX = 'erx'
export const RELEASE_TOGGLE_NOW = 'now'
export const RELEASE_TOGGLE_MP_CROSS_SELL = 'mp-cross-sell'
export const RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED = 'enabled'
export const RELEASE_TOGGLE_VARIANT_ATTRIBUTES = 'variant-attributes'
export const REBRANDING_TOGGLE = 'rebranding-it'
export const ERX_ADYEN_TOGGLE = 'erx-adyen'
export const ERX_ADYEN_MP_TOGGLE = 'erx-adyen-mp'
export const ERX_NOW_TOGGLE = 'erx-now'

// Experiments
export const XSELL_NEW_LAYOUT = 'xsell-new-layout'
export const PDP_CSW_NEW_ALGO = 'pdp-csw-new-algo'
export const CUSTOMER_REDIRECT = 'customer-redirect'
export const SERVICE_LINKS_CSW = 'service-links-csw'
export const ODS_CLIENT_FLOW = 'ods-client-flow'
export const ODS_PDP_MODAL = 'wsssh-188'
export const ODS_PDP_TOOLTIP = 'wsssh-859'
export const MEDICATION_PLAN_LINK = 'wsssh-1056'
export const NEW_HEADER = 'header'
export const PDP_APP_BANNER = 'pdp-app-banner'
export const PDP_APP_BANNER_AT = 'cro-931'
export const PDP_VARIANTS_POSITION = 'cro-459'
export const CSW_PRODUCT_TITLE = 'cro-780'
export const HOME_MULTILINE_CSW_ID_CHANGE = 'cro-804'
export const SERP_NOW_PUSH = 'cro-121'
export const SERP_LOAD_MORE = 'cro-179'
export const COLLECTIVE_ORDER_CHECKBOX = 'wstra-2044'
export const VARIANT_ATTRIBUTES = 'variant-attributes'
export const HOME_THIRD_CSW = 'cro-180'
export const SELLER_MODAL_XSELL = 'cro-734'
export const CART_VOUCHER_DISPLAY = 'cro-929'
export const NEW_CSW = 'cro-513'
export const FREE_SHIPPING_INDICATOR = 'cro-757'
export const PDP_SLIDER_IT_FR = 'cro-1068'
export const REPLACE_CUSTOMER_RATINGS_COM = 'cro-985'
export const REMOVE_ADD_TO_CART_COM_AT = 'cro-1095'
export const EXTENDED_SEARCHBOX_RESULTS = 'cro-1244'
export const CART_CTA_VARIANTS_IT = 'cro-1370'
export const NOW_CART_FUNCTIONALITY = 'wstra-3548'
export const HOME_SWAP_CSW_AND_SERVICES = 'cro-748'
export const SERP_REMOVE_ADD_TO_CART_CTA_COM = `cro-1446`
export const NOW_PDP_SERP_GB_FUNCTIONALITY = 'wstra-4055'

// ad-server experiments' name
export const AD_SERVER = 'ad-server'
export const AD_SERVER_SEARCH_PRODUCT = 'ad-se'
export const AD_SERVER_CROSSSELL_PRODUCT = 'ad-xs'
export const AD_SERVER_BANNER = 'ad-ba'
export const AD_SERVER_TRIAD_CAMPAIGN = 'rmadt-531'
